import { useState, useEffect } from "react";
import React from "react";
import "./uploadCsvFile.css";
import { useHistory } from "react-router-dom";
import ErrorMessage from "../common/errorMsg";
import SuccessMessage from "../common/successMsg";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";


import httpService from "../../services/http.service";

let UploadFile = (props) => {
    const history = useHistory();
    const [fileData, setFiledata] = useState();
    const [allFileRuleData, setallFileRuleData] = useState();
    const [duplicateKeyWarningMessage, setDuplicateKeyWarningMessage] = useState([]);
    const [enable, setEnable] = useState(true);


    const selectedFile = (event) => {
        setFiledata(event.target.files[0]);
    }
    useEffect(() => {
        GetAllFileData();
    }, [])

    useEffect(() => {
        // console.log(props.verifyTokenUser, "          ", props)
        if (!props.props.verifyTokenUser && history.location.pathname != '/cloudlogin') history.push('/cloudlogin')
    }, [props.props.verifyTokenUser])

    const UploadFile = async (event) => {
        event.preventDefault()
        if (!fileData) {
            ErrorMessage("Please select a File");
            return;
        }
        let userID = localStorage.getItem("UserId");
        let data = {
            userID: userID,
            file: fileData,
        };
        let res = await httpService.uploadFile("savefiledataindb", data)
        if (res && res.data.ack == "1") {
            SuccessMessage(res.data.message)
            setFiledata('')
            setDuplicateKeyWarningMessage(res.data.duplicateSecKey)
            GetAllFileData()
            document.getElementById("formFile").value = "";
        } else {
            ErrorMessage(res.data.message)
        }
    }

    const GetAllFileData = async () => {
        let userID = localStorage.getItem("UserId");
        let data = {
            userID: userID
        }
        try {
            let res = await httpService.getByBoj('getallcsvruledata', data)
                .catch((err) => {
                    if (err && err.response && err.response.status == 401) {
                        ErrorMessage("Session expired, please login again")
                    }
                    return
                });
            setallFileRuleData(res.data.data)
            if (res.data.data[0].userID === "admin") {
                setEnable(false)
            } else {
                setEnable(true)
            }
        }
        catch (err) {
            return
        }
    }
    const DeleteCSVData = async () => {
        let data = {
            userID: localStorage.getItem("UserId")
        }
        try {
            let res = await httpService.getByBoj('deletecsvruledata', data)
            if (res) {
                if (res.data.ack == '1') {
                    SuccessMessage(res.data.msg)
                    setallFileRuleData([])
                }
                else ErrorMessage(res.data.msg)
            }
            else {
                ErrorMessage('Something went wrong')
            }
        }
        catch (err) {
            ErrorMessage('Something went wrong')
            return
        }
    }
    return (
        <div>
            <form>
                <div className="form-boxdiv">
                    <div className="row form-boxtopline5">
                        <div className="col-9" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            {/* <div
                                onClick={() => {
                                    history.push("/clouddashboard");
                                }}
                            >
                                <Button className="back-btn"><i class="fa fa-chevron-left" aria-hidden="true"></i></Button>
                            </div> */}
                            <b>   UPLOAD AUTHENTICATION FILE {"  "} </b>


                        </div>
                        {/* <button className="btn btn-primary" onClick={() => { history.push("/clouddashboard") }}>Go Back</button> */}
                        {/* UPLOAD AUTHENTICATION FILE */}
                        {/* <button className="btn btn-primary" onClick={() => { history.push("/clouddashboard") }}>Go Back</button> */}
                    </div>

                    <div className="form-boxtopcont ">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label className="form-check-label">File :<i style={{ color: "red" }}>*</i></label>
                                    <input
                                        className="form-control pad-top-3"
                                        type="file"
                                        id="formFile"
                                        onChange={(event) => selectedFile(event)}
                                    />
                                </div>
                            </div>
                            {duplicateKeyWarningMessage.length ?
                                <div className="col-sm-6">
                                    <div className="warning-message">
                                        {"These account number already in use "}
                                        {duplicateKeyWarningMessage.map(item => {
                                            return (
                                                <>
                                                    <span>{item}{", "}</span>
                                                </>
                                            )
                                        })}
                                        <span className="fa fa-close authentication-close-btn " style={{ 'cursor': 'pointer' }} onClick={() => setDuplicateKeyWarningMessage([])}></span>

                                    </div>
                                </div> : ''}
                        </div>
                        <button
                            className="btn btn-danger marb-15"
                            onClick={(e) => {
                                e.preventDefault();
                                setFiledata("")
                                document.getElementById("formFile").value = "";
                                // history.goBack();
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-success marl-15 marb-15"
                            onClick={UploadFile}
                        >
                            Upload
                        </button>
                    </div>
                </div>
            </form>
            {allFileRuleData && allFileRuleData.length != 0 &&
                <form className="mt-2">
                    <div className="form-boxdiv">
                        <div className="d-flex flex-column">
                            <div className="form-boxtopline5 ">BILLING SYSTEM AUTHENTICATIONS
                                {enable ? <button
                                    className="btn btn-danger float-right"
                                    onClick={() => {
                                        let confirm = window.confirm("Do you want to clear all the data?");
                                        if (confirm) {
                                            DeleteCSVData()
                                        }
                                    }}
                                >Clear billing authentication data</button> : ''}
                            </div>
                        </div>
                        <div className="form-boxtopcont allrole-table-wrap  ">
                            <table className="allrole-table mt-2 mb-2" >
                                <thead>
                                    <tr>
                                        <th>Account</th>
                                        <th>Channel Id</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allFileRuleData && allFileRuleData.length && allFileRuleData.map(item => {

                                        return (
                                            <tr>
                                                <td>{item.secretKey}</td>
                                                <td>{item.channelID}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form>
            }
        </div>
    );
};

export default UploadFile;
